"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["history", "onFormChange", "onFormValidate", "onSubmit", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Form = function Form(_ref) {
  var history = _ref.history,
      onFormChange = _ref.onFormChange,
      onFormValidate = _ref.onFormValidate,
      onSubmit = _ref.onSubmit,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      forceValidation = _useState2[0],
      setForceValidation = _useState2[1];

  var formRef = (0, _react.useRef)();

  var getFormInputs = function getFormInputs() {
    var inputs = [];

    if (!formRef.current) {
      return inputs;
    }

    var inputQuery = formRef.current.querySelectorAll("input:not([no-data]), select:not([no-data]), textarea:not([no-data])");

    for (var i = 0, l = inputQuery.length; i < l; i++) {
      inputs.push(inputQuery[i]);
    }

    return inputs;
  };

  var markFieldsTouched = function markFieldsTouched(fields) {
    fields.forEach(function (f) {
      f.touched = true;
    });
  };

  var getFieldValue = function getFieldValue(field) {
    if (field.type === "checkbox") {
      return field.checked;
    }

    if (field.multiple) {
      return Array.from(field.selectedOptions).map(function (o) {
        return o.value;
      });
    }

    return field.value;
  };

  var buildFormData = function buildFormData() {
    var formInputs = getFormInputs();
    var formData = {};
    formInputs.forEach(function (f) {
      if (f.type === "radio") {
        if (f.checked) {
          formData[f.name || f.id] = f.value;
        }
      } else {
        var key = f.name || f.id;

        if (key) {
          formData[key] = getFieldValue(f);
        }
      }
    });
    return formData;
  };

  var buildFormState = function buildFormState() {
    var formInputs = getFormInputs();
    var formState = {};
    formInputs.forEach(function (f) {
      var key = f.name || f.id;

      if (key) {
        formState[key] = {
          value: getFieldValue(f),
          touched: f.touched
        };
      }
    });
    return formState;
  };

  var handleKeyDown = function handleKeyDown(ev) {
    // Tab key = '9'
    if (ev.keyCode === 9) {
      setForceValidation(true);
    }
  };

  var attachRealTimeValidation = function attachRealTimeValidation() {
    if (formRef && formRef.current) {
      var formInputs = getFormInputs();
      formInputs.forEach(function (f) {
        if (f.type === "checkbox") {
          f.removeEventListener("change", fieldValidation); // prevent duplicate binding

          f.addEventListener("change", fieldValidation);
        } else {
          f.removeEventListener("blur", fieldValidation); // prevent duplicate binding

          f.addEventListener("blur", fieldValidation);
        }
      });
    }
  };

  var fieldValidation = function fieldValidation(ev) {
    markFieldsTouched([ev.target]);

    if (onFormChange) {
      var formData = buildFormData();
      onFormChange(formData);
    }

    if (onFormValidate) {
      var formState = buildFormState();
      onFormValidate(formState);
    }

    setForceValidation(false);
  };

  var handleSubmit = function handleSubmit(ev) {
    ev.preventDefault();
    markFieldsTouched(getFormInputs());

    if (onFormValidate) {
      var formState = buildFormState();
      var hasErrors = onFormValidate(formState);

      if (!hasErrors) {
        performSubmit();
      }
    } else {
      performSubmit();
    }
  };

  var performSubmit = function performSubmit() {
    if (onSubmit) {
      var formData = buildFormData();
      onSubmit(formData);
    }
  };

  (0, _react.useEffect)(function () {
    attachRealTimeValidation();

    if (onFormChange) {
      var formData = buildFormData();
      onFormChange(formData);
    }

    return function () {
      var formInputs = getFormInputs();
      formInputs.forEach(function (f) {
        if (f.type === "checkbox") {
          f.removeEventListener("change", fieldValidation);
        } else {
          f.removeEventListener("blur", fieldValidation);
        }
      });
    };
  }, []);
  return _react["default"].createElement("form", _extends({}, props, {
    noValidate: true,
    onKeyDown: handleKeyDown,
    ref: formRef,
    onSubmit: handleSubmit
  }), children);
};

Form.propTypes = {
  onSubmit: _propTypes["default"].func,
  onFormValidate: _propTypes["default"].func,
  onFormChange: _propTypes["default"].func
};
var _default = Form;
exports["default"] = _default;